<template>

  <div class="pl20 pr20">
    <!-- <h3 class="pt30">项目管理专属</h3> -->
    <el-row :gutter="30" class="mb10">
      <el-col :span="6" v-for="(item,index) in classLists2" :key="index">
        <span @click="spantext($event)" :class="currentItem==item?'current':'' "><i :class="item">{{item}}</i></span>
      </el-col>
    </el-row>
    <!-- <h3 class="pt30">泰康专属</h3> -->
    <el-row :gutter="30" class="mb10">
      <el-col :span="6" v-for="(item,index) in classLists0" :key="index">
        <span @click="spantext($event)" :class="currentItem==item?'current':'' "><i :class="item">{{item}}</i></span>
      </el-col>
    </el-row>
    <!-- <h3 class="pt30">系统自带</h3> -->
    <el-row :gutter="30" class="mb10">
      <el-col :span="6" v-for="(item,index) in classLists" :key="index">
        <span @click="spantext($event)" :class="currentItem==item?'current':'' "><i :class="item">{{item}}</i></span>
      </el-col>
    </el-row>
    <!-- <h3 class="pt30">其他</h3> -->
    <el-row :gutter="30" >
      <el-col :span="6" v-for="(item,index) in classLists1" :key="index">
        <span @click="spantext($event)" :class="currentItem==item?'current':'' "><i :class="item">{{item}}</i></span>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
  name: 'all_icons',
  components: {

  },
  data() {
    return {
      basic_url: Config.dev_url,
      classLists0: [
        'tkicon-acceptance',
        'tkicon-apps',
        'tkicon-assets',
        'tkicon-assetsinventory',
        'tkicon-assetspoof',
        'tkicon-budget',
        'tkicon-calendar',
        'tkicon-caret-down',
        'tkicon-caret-up',
        'tkicon-close-circle-fill',
        'tkicon-demand',
        'tkicon-down',
        'tkicon-fall',
        'tkicon-file',
        'tkicon-indent',
        'tkicon-left',
        'tkicon-notice',
        'tkicon-outdent',
        'tkicon-point',
        'tkicon-purchase',
        'tkicon-report',
        'tkicon-right',
        'tkicon-rise',
        'tkicon-search',
        'tkicon-setapp',
        'tkicon-setting',
        'tkicon-sync',
        'tkicon-up',
        'tkicon-warehousing',
        'tkicon-workflow',
      ],
      classLists2: [
        'proicon-bid',
        'proicon-construction',
        'proicon-contract',
        'proicon-cost',
        'proicon-design',
        'proicon-eam',
        'proicon-files',
        'proicon-Interface',
        'proicon-knowledge',
        'proicon-partners',
        'proicon-progress',
        'proicon-purchase',
        'proicon-quility',
        'proicon-risk',
        'proicon-running',
        'proicon-safe',
        'proicon-service',
        'proicon-standard',
        'proicon-startup',
        'proicon-technology',
        'proicon-testing',
        'proicon-track',
        'proicon-transfer',
        'proicon-transport',
      ],
      classLists: [
        'icon-setting3',
        'icon-data3',
        'icon-ports3',
        'icon-reminding3',
        'icon-report2',
        'icon-sample3',
        'icon-search3',
        'icon-testing3',
        'icon-correct1',
        'icon-date-limit',
        'icon-arrow2-down',
        'icon-arrow2-left',
        'icon-arrow2-right',
        'icon-arrow2-up',
        'icon-add',
        'icon-arrow1-down',
        'icon-arrow1-left',
        'icon-arrow1-right',
        'icon-arrow1-up',
        'icon-back',
        'icon-calendar1',
        'icon-checkbox-focus',
        'icon-checkbox-normal',
        'icon-close1',
        'icon-close2',
        'icon-contract',
        'icon-data',
        'icon-department',
        'icon-device',
        'icon-distribution',
        'icon-edit',
        'icon-excel',
        'icon-file-normal',
        'icon-file-open',
        'icon-file-text',
        'icon-inspection',
        'icon-inventory-line-callin',
        'icon-inventory-line-callout',
        'icon-inventory-line-code',
        'icon-inventory-line-grant',
        'icon-inventory-line-inventory',
        'icon-inventory-line-requisition',
        'icon-inventory-line-return',
        'icon-inventory-line',
        'icon-inventory',
        'icon-key',
        'icon-kpi',
        'icon-log',
        'icon-login-log',
        'icon-map',
        'icon-maximization',
        'icon-menu1',
        'icon-menu2',
        'icon-menu3',
        'icon-minimize',
        'icon-monitor',
        'icon-next',
        'icon-notice',
        'icon-order-down',
        'icon-order-normal',
        'icon-order-up',
        'icon-pdf',
        'icon-plan',
        'icon-ppt',
        'icon-preventive',
        'icon-previous',
        'icon-print',
        'icon-project',
        'icon-purchase',
        'icon-radio-focus',
        'icon-radio-normal',
        'icon-refresh',
        'icon-reporting',
        'icon-restore',
        'icon-role-site',
        'icon-safe',
        'icon-search',
        'icon-start',
        'icon-stop',
        'icon-task',
        'icon-time',
        'icon-trash',
        'icon-user',
        'icon-word',
        'icon-wordbook',
        'icon-worklist',
        'icon-attachments',
        'icon-book',
        'icon-check',
        'icon-correct',
        'icon-hot',
        'icon-list',
        'icon-man',
        'icon-move',
        'icon-new',
        'icon-question',
        'icon-woman',
        'icon-activity',
        'icon-airplay',
        'icon-alert-circle',
        'icon-alert-octagon',
        'icon-alert-triangle',
        'icon-align-center',
        'icon-align-justify',
        'icon-align-left',
        'icon-align-right',
        'icon-align-left',
        'icon-archive',
        'icon-arrow-down-circle',
        'icon-arrow-down-left',
        'icon-arrow-down-right',
        'icon-arrow-down',
        'icon-arrow-down-left-circle',
        'icon-arrow-left',
        'icon-arrow-right-circle',
        'icon-arrow-right',
        'icon-arrow-up-circle',
        'icon-arrow-up-left',
        'icon-arrow-up-right',
        'icon-arrow-up',
        'icon-at-sign',
        'icon-award',
        'icon-bar-chart-2',
        'icon-bar-chart',
        'icon-battery-charging',
        'icon-battery',
        'icon-bell-off',
        'icon-bell',
        'icon-bluetooth',
        'icon-bold',
        'icon-book-open',
        'icon-book2',
        'icon-bookin',
        'icon-bookmark',
        'icon-box',
        'icon-briefcase',
        'icon-calendar',
        'icon-camera-off',
        'icon-camera',
        'icon-cast',
        'icon-check-circle',
        'icon-check-square',
        'icon-checkout',
        'icon-clipboard',
        'icon-clock',
        'icon-cloud-drizzle',
        'icon-cloud-lightning',
        'icon-cloud-off',
        'icon-cloud-rain',
        'icon-cloud-snow',
        'icon-cloud',
        'icon-code',
        'icon-codepen',
        'icon-command',
        'icon-compass',
        'icon-copy',
        'icon-corner-down-left',
        'icon-corner-down-right',
        'icon-corner-left-down',
        'icon-corner-left-up',
        'icon-corner-right-down',
        'icon-corner-right-up',
        'icon-corner-up-left',
        'icon-corner-up-right',
        'icon-cpu',
        'icon-credit-card',
        'icon-crop',
        'icon-crosshair',
        'icon-dashboard',
        'icon-database',
        'icon-delete',
        'icon-double-angle-down',
        'icon-double-angle-left',
        'icon-double-angle-right',
        'icon-double-angle-up',
        'icon-download-cloud',
        'icon-download',
        'icon-droplet',
        'icon-edit-3',
        'icon-edit2',
        'icon-envelope',
        'icon-external-link',
        'icon-eye-off',
        'icon-eye',
        'icon-fast-forward',
        'icon-file-minus',
        'icon-file-plus',
        'icon-file-text1',
        'icon-file',
        'icon-film',
        'icon-filter',
        'icon-flag',
        'icon-folder-minus',
        'icon-folder-plus',
        'icon-folder',
        'icon-gift',
        'icon-git-branch',
        'icon-git-commit',
        'icon-git-merge',
        'icon-git-pull-request',
        'icon-globe',
        'icon-grid',
        'icon-hard-drive',
        'icon-hash',
        'icon-headphones',
        'icon-heart',
        'icon-help-circle',
        'icon-home',
        'icon-inbox',
        'icon-info',
        'icon-instagram',
        'icon-italic',
        'icon-layers',
        'icon-layout',
        'icon-life-buoy',
        'icon-link-2',
        'icon-link',
        'icon-list-alt',
        'icon-loader',
        'icon-lock',
        'icon-log-in',
        'icon-log-out',
        'icon-map-pin',
        'icon-map1',
        'icon-maximize-2',
        'icon-maximize',
        'icon-message-circle',
        'icon-message-square',
        'icon-mic-off',
        'icon-mic',
        'icon-minimize-2',
        'icon-minimize1',
        'icon-minus-circle',
        'icon-minus-square',
        'icon-monitor1',
        'icon-moon',
        'icon-more-horizontal',
        'icon-more-vertical',
        'icon-move1',
        'icon-music',
        'icon-navigation-2',
        'icon-navigation',
        'icon-octagon',
        'icon-package',
        'icon-paperclip',
        'icon-pencil',
        'icon-percent',
        'icon-phone-call',
        'icon-phone-forwarded',
        'icon-phone-missed',
        'icon-phone-off',
        'icon-phone-outgoing',
        'icon-phone',
        'icon-picture',
        'icon-pie-chart',
        'icon-plus-circle',
        'icon-plus-square',
        'icon-pocket',
        'icon-power',
        'icon-printer',
        'icon-radio',
        'icon-power',
        'icon-refresh-ccw',
        'icon-refresh-cw',
        'icon-repeat',
        'icon-rewind',
        'icon-rotate-ccw',
        'icon-rotate-cw',
        'icon-save',
        'icon-scissors',
        'icon-search1',
        'icon-send',
        'icon-server',
        'icon-settings',
        'icon-share-2',
        'icon-shield-off',
        'icon-shield',
        'icon-shopping-bag',
        'icon-shopping-cart',
        'icon-shuffle',
        'icon-sidebar',
        'icon-skip-back',
        'icon-skip-forward',
        'icon-slack',
        'icon-slash',
        'icon-sliders',
        'icon-smartphone',
        'icon-speaker',
        'icon-star',
        'icon-sun',
        'icon-sunrise',
        'icon-sunset',
        'icon-tablet',
        'icon-tag',
        'icon-target',
        'icon-terminal',
        'icon-thermometer',
        'icon-thumbs-down',
        'icon-thumbs-up',
        'icon-toggle-left',
        'icon-toggle-right',
        'icon-trash-2',
        'icon-trash1',
        'icon-trending-down',
        'icon-trending-up',
        'icon-triangle',
        'icon-truck',
        'icon-tv',
        'icon-type',
        'icon-umbrella',
        'icon-underline',
        'icon-unlock',
        'icon-upload-cloud',
        'icon-video-off',
        'icon-video',
        'icon-voicemail',
        'icon-volume-1',
        'icon-volume-2',
        'icon-volume-x',
        'icon-volume',
        'icon-watch',
        'icon-wifi-off',
        'icon-wifi',
        'icon-wind',
        'icon-x-circle',
        'icon-x-square',
        'icon-x',
        'icon-youtube',
        'icon-zap-off',
        'icon-zap',
        'icon-zoom-in',
        'icon-zoom-out',
      ],
      ////qita
      classLists1: [
        'icon-stopwatch',
        'icon-star-full',
        'icon-heart1',
        'icon-heart-broken',
        'icon-man1',
        'icon-woman1',
        'icon-man-woman',
        'icon-happy',
        'icon-happy2',
        'icon-smile',
        'icon-smile2',
        'icon-tongue',
        'icon-tongue2',
        'icon-sad',
        'icon-sad2',
        'icon-wink',
        'icon-wink2',
        'icon-grin',
        'icon-grin2',
        'icon-cool',
        'icon-cool2',
        'icon-angry',
        'icon-angry2',
        'icon-evil',
        'icon-evil2',
        'icon-shocked',
        'icon-shocked2',
        'icon-baffled',
        'icon-baffled2',
        'icon-confused',
        'icon-confused2',
        'icon-neutral',
        'icon-neutral2',
        'icon-hipster',
        'icon-hipster2',
        'icon-wondering',
        'icon-wondering2',
        'icon-sleepy',
        'icon-sleepy2',
        'icon-frustrated',
        'icon-frustrated2',
        'icon-crying',
        'icon-crying2',
      ],

      childValue: '',
      currentItem: ''
    }
  },
  mounted() {

  },
  methods: {
    spantext(event) {
      var el = event.target;
      var childValue = el.innerText;
      this.currentItem = el.innerText;
      // childByValue是在父组件on监听的方法
      // 第二个参数this.childValue是需要传的值
      console.log(childValue)
      this.$emit('childByValue', childValue);
    }
  },
}
</script>

<style scoped>
i[class*=" icon-"]:before,
i[class^="icon-"]:before {
  margin-right: 5px;
}
.el-col span {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 10px 0px rgba(223, 229, 234, 1);
  display: block;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  margin-bottom: 5px;
}
.el-col span:hover,
.el-col span.current {
  background: rgba(241, 243, 253, 1);
  color: #576fae;
}
.el-col span.current {
  color: #6585df;
}
</style>
